export default "__VITE_ASSET__cc072aa7__"